import React from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export const Tooltip: React.FC<TooltipProps> = ({ 
  content, 
  children, 
  position = 'top' 
}) => (
  <div 
    style={{ 
      position: 'relative', 
      display: 'inline-block',
      cursor: 'help'
    }}
    title={content}
  >
    {children}
  </div>
);
